"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postSourceOfFundDescription = exports.deleteKYCDocument = exports.uploadKYCDocument = void 0;
const uploadKYCDocument = (serverURL, appAxios) => async file => {
  const formData = new FormData();
  formData.append("file", file);
  return await appAxios.post(`${serverURL}/yoti/document`, formData, {
    withCredentials: true,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
exports.uploadKYCDocument = uploadKYCDocument;
const deleteKYCDocument = (serverURL, appAxios) => async documentId => await appAxios.delete(`${serverURL}/yoti/document/${documentId}`, {
  withCredentials: true
});
exports.deleteKYCDocument = deleteKYCDocument;
const postSourceOfFundDescription = (serverURL, appAxios) => async sourceOfFundDescription => {
  return await appAxios.post(`${serverURL}/yoti/sourceOfFund`, {
    sourceOfFundDescription
  }, {
    withCredentials: true
  });
};
exports.postSourceOfFundDescription = postSourceOfFundDescription;